import { render, staticRenderFns } from "./MoleculeEditionBillingArtificialIntelligenceSettings.vue?vue&type=template&id=c48384f4"
import script from "./MoleculeEditionBillingArtificialIntelligenceSettings.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingArtificialIntelligenceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports